import React from 'react'
import MaterialSymbol from '../material-symbol'

const ChatBubble = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="chat_bubble" {...props} />
))

ChatBubble.displayName = 'ChatBubble'

export default ChatBubble
